<template>
  <div>
    <b-overlay rounded="sm">
      <h1>Dashboard</h1>
    </b-overlay>

    <div class="cardContainer">
      <b-card class="cardContent" v-if="isAppInFront">
        <img src="@/assets/images/dashboard/tools.svg" class="image" />
        <b-card-title class="custom-class">Front AI</b-card-title>
        <ul>
          <li>
            <router-link
              class="nav-links"
              to="/secure/ai/conversation-summarizer"
              >Conversation Summarizer
            </router-link>
          </li>
        </ul>
      </b-card>
      <b-card class="cardContent">
        <img src="@/assets/images/dashboard/orders.svg" class="image" />
        <b-card-title class="custom-class">Orders</b-card-title>
        <ul>
          <li>
            <router-link
              class="nav-links"
              to="/secure/orders/manual-fullfillment"
              >Manual Fulfillment
            </router-link>
          </li>
          <li>
            <router-link
              class="nav-links"
              to="/secure/orders/replacement-order-automation"
              >Order Replacement Automation
            </router-link>
          </li>
          <li>
            <router-link
              class="nav-links"
              to="/secure/orders/checkout-automation"
              >Checkout Automation
            </router-link>
          </li>
          <li>
            <router-link
              class="nav-links"
              to="/secure/orders/bulk-order-link-creator"
              >Bulk Order Link Creator
            </router-link>
          </li>
          <li>
            <router-link
              class="nav-links"
              to="/secure/orders/upgrade-automation"
              >Upgrade Automation
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/orders/mass-adjust-tags"
              >Mass Adjust Tags
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/reports/pull-automation"
              >Order Adjustments
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/orders/bulkorder"
              >Bulk Order
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/orders/failedorder"
              >Place Failed Order
            </router-link>
          </li>
        </ul>
      </b-card>
      <b-card class="cardContent">
        <img src="@/assets/images/dashboard/labels.svg" class="image" />
        <b-card-title class="custom-class">Labels</b-card-title>
        <ul>
          <li>
            <router-link
              class="nav-links"
              to="/secure/exporter/callia-excel-to-pdf"
              >SK & HX Excel to PDF
            </router-link>
          </li>
          <li>
            <router-link
              class="nav-links"
              to="/secure/exporter/large-labels-new"
              >EDM, BC, CG, TR, OT, MTL & MB NEW LABELS LINK
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/exporter/callia-gift-box"
              >Curated Gift Box
            </router-link>
          </li>
          <li>
            <router-link
              class="nav-links"
              to="/secure/exporter/callia-word-to-pdf"
              >Word to PDF
            </router-link>
          </li>
          <li>
            <router-link
              class="nav-links"
              to="/secure/exporter/export-process-report"
              >Label Processes
            </router-link>
          </li>
        </ul>
      </b-card>
      <b-card class="cardContent">
        <img src="@/assets/images/dashboard/generate.svg" class="image" />
        <b-card-title class="custom-class">Order Pulls</b-card-title>
        <ul>
          <li>
            <router-link class="nav-links" to="/secure/reports/pull-schedules"
              >Order Pulls Calendar
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/reports/reports-list"
              >Order Pulls and Reports config
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/reports/schedules-list"
              >Order Pulls Schedules List
            </router-link>
          </li>
          <!-- <li>
            <router-link class="nav-links" to="/secure/reports/rules-list">Order Pulls Rules list
            </router-link>
          </li> -->
          <li>
            <router-link
              class="nav-links"
              to="/secure/orders/latest-order-pulls"
              >Latest OrderPulls
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/reports/bulk-pre-pulls"
              >Bulk Pre Pulls
            </router-link>
          </li>
          <li>
            <router-link
              class="nav-links"
              to="/secure/reports/inventory-forecast"
              >Inventory Forecast Report
            </router-link>
          </li>
        </ul>
      </b-card>
      <b-card class="cardContent">
        <img src="@/assets/images/dashboard/operation.svg" class="image" />
        <b-card-title class="custom-class">Operation (SMS)</b-card-title>
        <ul>
          <li>
            <router-link class="nav-links" to="/secure/unsubscribe/phone"
              >Unsubscribe Phone
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/unsubscribe/email"
              >Unsubscribe Email
            </router-link>
          </li>

          <li>
            <router-link
              class="sidebar-link"
              to="/secure/unsubscribe/customer-list"
              >Edit Customer List</router-link
            >
          </li>
          <li>
            <router-link class="nav-links" to="/secure/sms/history"
              >SMS History
            </router-link>
          </li>
          <li>
            <router-link
              class="nav-links"
              to="/secure/delivery-notification/SMS"
            >
              SMS Template Settings
            </router-link>
          </li>
          <li>
            <router-link
              class="nav-links"
              to="/secure/delivery-notification/schedules"
            >
              Text Schedules
            </router-link>
          </li>
          <li>
            <router-link
              class="nav-links"
              to="/secure/mass-sms-hub/onfleet-drivers-today"
            >
              Onfleet Drivers Today
            </router-link>
          </li>
        </ul>
      </b-card>
      <b-card class="cardContent">
        <img src="@/assets/images/dashboard/tools.svg" class="image" />
        <b-card-title class="custom-class">Customer Account</b-card-title>
        <ul>
          <li>
            <router-link class="nav-links" to="/secure/customer/password-reset"
              >Reset Password
            </router-link>
          </li>
        </ul>
      </b-card>
      <b-card class="cardContent">
        <img src="@/assets/images/dashboard/labels.svg" class="image" />
        <b-card-title class="custom-class">Callia Rules</b-card-title>
        <ul>
          <li>
            <router-link class="nav-links" to="/secure/orders/cutoffs"
              >CutOffs
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/orders/cutoff-report"
              >Delivery Cutoff Report
            </router-link>
          </li>
          <li>
            <router-link class="sidebar-link" to="/secure/rules/dates-closed"
              >Dates Closed
            </router-link>
          </li>
          <li>
            <router-link class="sidebar-link" to="/secure/rules/dates-available"
              >Dates Available
            </router-link>
          </li>
        </ul>
      </b-card>
      <b-card class="cardContent">
        <img src="@/assets/images/dashboard/orders.svg" class="image" />
        <b-card-title class="custom-class">Places</b-card-title>
        <ul>
          <li>
            <router-link class="sidebar-link" to="/secure/region"
              >Region</router-link
            >
          </li>
          <li>
            <router-link class="sidebar-link" to="/secure/zone"
              >Zone</router-link
            >
          </li>
          <li>
            <router-link class="sidebar-link" to="/secure/town"
              >Town</router-link
            >
          </li>
          <li>
            <router-link class="sidebar-link" to="/secure/postalcode"
              >Postal Code</router-link
            >
          </li>
        </ul>
      </b-card>
      <b-card class="cardContent">
        <img src="@/assets/images/dashboard/operation.svg" class="image" />
        <b-card-title class="custom-class">Operation (Zones)</b-card-title>
        <ul>
          <li>
            <router-link class="sidebar-link" to="/secure/zone-delivery-rate"
              >Zone Delivery Rate
            </router-link>
          </li>
          <li>
            <router-link
              class="sidebar-link"
              to="/secure/special-zone-delivery-rate"
              >Special Zone Delivery Rate
            </router-link>
          </li>
        </ul>
      </b-card>
      <b-card class="cardContent">
        <img src="@/assets/images/dashboard/tools.svg" class="image" />
        <b-card-title class="custom-class">Tools</b-card-title>
        <ul>
          <li>
            <router-link class="nav-links" to="/secure/ops/postal-code-query"
              >Do we deliver to
            </router-link>
          </li>
          <li>
            <router-link
              class="nav-links"
              to="/secure/orders/delivery-window-query"
              >Query Delivery Window
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/ops/links"
              >Ops Links
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/ops/creds/"
              >Ops Credentials
            </router-link>
          </li>
        </ul>
      </b-card>
      <b-card class="cardContent">
        <img src="@/assets/images/dashboard/orders.svg" class="image" />
        <b-card-title class="custom-class">Products</b-card-title>
        <ul>
          <li>
            <router-link class="nav-links" to="/secure/products/product-uploads"
              >Product Uploads
            </router-link>
          </li>
        </ul>
      </b-card>
      <b-card class="cardContent">
        <img src="@/assets/images/dashboard/tools.svg" class="image" />
        <b-card-title class="custom-class">Giftset Alert</b-card-title>
        <ul>
          <li>
            <router-link class="nav-links" to="/secure/giftset/template"
              >Giftset Alert Template
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/giftset/alert"
              >Giftset Alert List
            </router-link>
          </li>
        </ul>
      </b-card>
      <b-card class="cardContent">
        <img src="@/assets/images/dashboard/gift.svg" class="image" />
        <b-card-title class="custom-class">Greets</b-card-title>
        <ul>
          <li>
            <router-link class="nav-links" to="/secure/greets/add-greets"
              >Add Greet
            </router-link>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/greets/greet-list"
              >Greet List</router-link
            >
          </li>
        </ul>
      </b-card>
      <b-card class="cardContent">
        <img src="@/assets/images/dashboard/tools.svg" class="image" />
        <b-card-title class="custom-class">Dev Corner</b-card-title>
        <ul>
          <li>
            <router-link
              class="nav-links"
              to="/secure/dev-corner/dev-ecs-manage"
              >Dev ECS Manage
            </router-link>
          </li>
          <li>
            <router-link
              class="nav-links"
              to="/secure/dev-corner/deploy-maintenance-site"
              >Deploy Maintenance Site
            </router-link>
          </li>
          <li>
            <a class="nav-links" target="_blank" href="https://tools.calliaops.com/"
              >CalliaOps Tool Publisher
            </a>
          </li>
          <li>
            <router-link class="nav-links" to="/secure/exporter/large-labels"
              >EDM, BC, CG, TR, OT, MTL & MB NEW LABELS LINK(Old, Slow)
            </router-link>
          </li>
        </ul>
      </b-card>
    </div>
  </div>
</template>

<script>
import Front from "@frontapp/plugin-sdk";
import {
  TruckIcon,
  PackageIcon,
  FileTextIcon,
  GiftIcon
} from "vue-feather-icons";

export default {
  components: {},
  data() {
    return {
      isAppInFront: false
    };
  },
  created() {
    try {
      Front.contextUpdates.subscribe(async context => {
        this.isAppInFront = true;
      });
    } catch (e) {
      this.isAppInFront = false;
    }
  }
};
</script>

<style>
.cardContainer {
  display: grid;
  grid-gap: 20px;
}

.cardContent {
  text-align: center;
  background-color: #fdfdfd;
  color: #45494a;
  border-radius: 1rem !important;
  box-shadow: 2px 2px 6px #bbbbbb;
}

.cardContainer img {
  width: 45%;
  height: 150px;
}

/* remove this to unhide the delivery card */
#SchedulesMenu {
  display: none;
}

.cardContent ul {
  list-style: none;
  text-align: center;
  padding-right: 10px;
}

.cardContent ul li {
  padding-bottom: 0.1rem;
}

.cardContainer a {
  color: #6c757d;
}

.cardContainer a:hover {
  color: #b4bbc1;
}

.custom-class {
  padding: 0.3rem;
  margin: auto 0;
}

.nav-links {
  margin-right: 10px;
}

.cardContainer {
  grid-template-columns: repeat(3, 1fr);
}

@media (max-width: 1100px) {
  .cardContainer {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 900px) {
    .cards {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

@media (max-width: 600px) {
  .cardContainer {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
